export const UI_ICON_BUTTON_BLANK_TYPE = 'blankType';
export const UI_ICON_BUTTON_BLACK_TYPE = 'blackType';
export const UI_ICON_BUTTON_WHITE_TYPE = 'whiteType';
export const UI_ICON_BUTTON_CANCEL_TYPE = 'cancelType';
export const UI_ICON_BUTTON_FILL_TYPE = 'fillType';
export const UI_ICON_BUTTON_OUTLINE_TYPE = 'outlineType';
export const UI_ICON_BUTTON_PROPERTY_WEBSITE_TYPE = 'propertyOutlineType';
export const UI_ICON_BUTTON_PROPERTY_WEBSITE_AGENT_TYPE = 'propertyAgentOutlineType';
